import ReconciliationView from '@/features/reconciliation/ReconciliationView.vue'
import ReconciliationListView from './ReconciliationListView.vue'

export const RECONCILIATION_VIEW = {
    componentName: 'ReconciliationView',
    component: ReconciliationView,
    meta: { requiresOrg: true }
}

export const RECONCILIATION_LIST_VIEW = {
    componentName: 'ReconciliationListView',
    component: ReconciliationListView,
    meta: { requiresOrg: true }
}
